export default {
  firstNote: 60,
  keyboardSize: 12,
};
